export default __webpack_public_path__ + "static/media/twitter.bf3870c8.svg";